/* import __COLOCATED_TEMPLATE__ from './uninstallation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();